import * as React from "react";
import { IProposalLists } from "./interfaces";

interface ISuggestionsContext {
    lists: IProposalLists;
    updateLists?: (lists: IProposalLists) => void;
}

export const ProposalsContext = React.createContext<ISuggestionsContext>(null);
